/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ArrayExtensions, ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IProductSpecificationViewProps } from '@msdyn365-commerce-modules/product-specification';
import { WS_DELIVERY_TIME } from '../../../configuration/attributes';

const ProductSpecificationView: React.FC<IProductSpecificationViewProps> = props => {
    const { ProductSpecification, ProductSpecificationTableProps, ProductSpecificationTableBodyProps, productSpecificationResult } = props;
    const filteredRowData =
        productSpecificationResult &&
        ArrayExtensions.hasElements(productSpecificationResult) &&
        productSpecificationResult
            .filter(row => !ObjectExtensions.isNullOrUndefined(row))
            .map(row => {
                if (!React.isValidElement(row)) {
                    return row;
                }

                const childrenArray = React.Children.toArray((row as React.ReactElement).props.children);

                for (const child of childrenArray) {
                    if (!React.isValidElement(child)) {
                        continue;
                    }

                    const productName = (child.props as { productName?: string })?.productName;
                    if (productName === WS_DELIVERY_TIME) {
                        return null;
                    }
                }

                return row;
            })
            .filter(Boolean);

    const tableBodyProps = {
        ...ProductSpecificationTableBodyProps,
        children: filteredRowData
    };

    return filteredRowData && ArrayExtensions.hasElements(filteredRowData) ? (
        <Module {...ProductSpecification}>
            {props.title}
            <Node {...ProductSpecificationTableProps}>
                <Node {...tableBodyProps} />
            </Node>
        </Module>
    ) : null;
};

export default ProductSpecificationView;
